import CurrencyPairItemFX from './CurrencyPairItemFX';

export default CurrencyPairItemFX;
